
import './App.css';
// import { AdminGet } from './component/AdminGet';
// import Channels from './Pages/Channels';
// import { Instagram } from './Pages/Instagram';
// import { Calender } from './Calender/Calender';

import { RouterPage } from './Pages/RouterPage';

function App() {
  return (
    <div className="App">
     {/* <Home/> */}
    
    <RouterPage/>
    {/* <Calender/> */}
    {/* <Instagram/> */}
    {/* <Channels/> */}
    {/* <AdminGet/> */}

    </div>
  );
}

export default App;
